<template>
    <div class="manage" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="0">
        <div class="manage_left">
            <div class="manage_left__title">
                <span>我的设备</span>
            </div>
            <div class="manage_left__content">
                <div class="manage_left__content_item" :class="activeIndex == index ? 'activestyles' : ''"
                    @click="changeActiveIndex(item, index)" v-for="item, index in tableData" :key="index">
                    {{ item.T_sn }}
                </div>
            </div>
        </div>
        <div class="manage_right">
            <div class="manage_right-top">
                <div class="manage_right-top_maisn">
                    <div class="manage_right-top_maisn_left" :class="subData.T_online != 1 ? 'meterStyle' : ''">
                        <div>{{ subData.T_online != 1 ? '离线' : '在线' }}</div>
                        <div>设备状态</div>
                    </div>
                    <div class="manage_right-top_maisn_right" :style="{ color: states == 0 ? 'red' : '#00bfff' }">
                        <div class="manage_right-top_maisn_right_item">设备分类：{{ subData.T_tab }}</div>
                        <div class="manage_right-top_maisn_right_item">设备编号：{{ subData.T_sn }}</div>
                        <div class="manage_right-top_maisn_right_item">设备类型：{{ subData.T_ProductID }}</div>
                        <div class="manage_right-top_maisn_right_item">添加时间：{{ subData.CreateTime }}</div>
                    </div>
                </div>
                <div class="manage_right-top_btn" @click="delectFun(subData)">
                    删除设备
                </div>
            </div>
            <div class="manage_right-bottom">
                <el-table :data="setTableData(subData)" row-key="newId" height="100%"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                    <el-table-column prop="T_name" label="属性名称" width="130"></el-table-column>
                    <el-table-column prop="T_tab" label="属性标识符" width="130"></el-table-column>
                    <el-table-column label="属性类型" width="150" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{
                                scope.row.T_type == 1 ? 'number(数值)' :
                                    scope.row.T_type == 2 ? 'string(字符串)' :
                                        scope.row.T_type == 3 ? 'string(字符串)' :
                                            scope.row.T_type == 4 ? 'boolean(布尔值)' :
                                                scope.row.T_type == 8 ? 'time(时间)' :
                                                    scope.row.T_type == 10 ? 'object(对象)' : ''
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="只读状态" width="80" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{ scope.row.T_read ? '只读' : '读写' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="扩展选项" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <!-- T_type: 1 数值, 2 字符串  3 枚举 4 布尔  8 时间 10对象 -->
                            <div v-if="[1, 2].includes(scope.row.T_type)">
                                {{ scope.row.T_attr.dvalue ? '默认值：' + scope.row.T_attr.dvalue : '' }}
                                {{ scope.row.T_attr.unit ? '单位：' + scope.row.T_attr.unit : '' }}
                                {{ scope.row.T_attr.accuracy ? '精度：' + scope.row.T_attr.accuracy : '' }}
                                {{ scope.row.T_attr.min ? '最小值：' + scope.row.T_attr.min : '' }}
                                {{ scope.row.T_attr.max ? '最大值：' + scope.row.T_attr.max : '' }}
                            </div>

                            <!-- <div v-if="scope.row.T_type == 3 || scope.row.T_type == 4">{{ JSON.stringify(scope.row.T_attr).slice(1, -1) }}</div> -->
                            <div v-if="[3, 4].includes(scope.row.T_type)">{{
                                JSON.stringify(scope.row.T_attr).slice(1, -1) }}
                            </div>

                            <div v-if="scope.row.T_type == 8" style="width: 100%;">
                                {{ scope.row.T_attr.dvalue ? '默认值：' + scope.row.T_attr.dvalue : '' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="当前值" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{ initDictpresent(subData.T_dataJson, scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="操作" width="80">
                        <template slot-scope="scope">
                            <span @click="handleEdit(subData, scope.row)">编辑</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-drawer title="编辑" :append-to-body="true" size="30%" :visible.sync="innerDrawer">
            <div style="padding: 20px;">
                <el-form ref="form.T_data">
                    <el-form-item :label="item.label" v-for="item, index in isFormList" :key="index">
                        <el-input v-model="item.value" @blur="blurFun(item)"></el-input>
                        <p style="font-size: 12px;color: red" v-if="blurFun(item)">请输入true或者false</p>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即提交</el-button>
                        <el-button @click="innerDrawer = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { steTableDataFn, MovingFun } from "./js/MovingData.js";
import {
    DevicepushFun, DevicedeleteFun,
    getGroupList,
    getdeviceGetFun
} from "./js/MovingRingApi.js";
export default {
    data() {
        return {
            innerDrawer: false,
            form: {
                T_uuid: '0b7a6a23',
                T_sn: "2024168317603592",
                T_password: "TpJWG4hr8iNuEdbP",
                T_data: {}
            },
            isFormList: [],
            states: 1,
            tableData: [],
            activeIndex: 0,
            subData: {},//当前下面的子选项的值
        }
    },
    mounted() {
        this.getGroupList()
    },
    methods: {
        //分组列表
        async getGroupList() {
            let res = await getGroupList({})
            let arr = [...res] || []
            let finalArr = []
            // 用于存储最终结果
            for (let item of arr) {
                let { T_sn } = item
                item.arrJson = []
                for (let i of T_sn) {
                    let reslut = await this.fetchGetDev(i)
                    if (reslut.Code == 200 && reslut.Data) {
                        item.arrJson.push(reslut.Data)
                    }
                }
                // 如果 arrJson 长度不为 0，将 item 添加到 finalArr
                if (item.arrJson.length > 0) {
                    finalArr.push(item);
                }
            }
            this.manageData(finalArr)
        },

        //设备列表
        async fetchGetDev(sn) {
            return new Promise((reslove) => {
                getdeviceGetFun({ T_sn: sn }).then(res => {
                    if (res.Code == 200 && res.Data) {
                        let d = MovingFun(res || [])
                        reslove(d)
                    } else {
                        reslove(res)
                    }
                })
            })

        },

        manageData(finalArr) {
            let arr = [...finalArr]
            let reslut = arr.map(item => {
                return item.arrJson.map(subItem => {
                    // 合并 T_sn 到每个子对象  
                    return { ...subItem, T_tab: item.T_tab };
                });
            }).flat(); // 如果环境支持 flat 方法
            this.tableData = reslut
            this.changeActiveIndex(this.tableData[0], 0)
        },

        delectFun(event) {
            let self = this
            DevicedeleteFun({ T_sn: event.T_sn }).then(res => {
                if (res.Code == 200) {
                    this.$message.success('删除成功')
                    self.getGroupList()
                }
            })
        },
        setTableData(data) {
            if (Object.keys(data).length != 0) {
                return steTableDataFn(data)
            }

        },
        changeActiveIndex(item, index) {
            this.activeIndex = index
            this.subData = item
        },
        initDictpresent(arr, str) {
            let isSplit = str.newId.split('.')
            let settab;
            if (isSplit.length == 1) {
                settab = isSplit[0].slice(0, isSplit[0].length - 1)
                return ''
            } else {
                settab = isSplit
                const b = arr.find(item => item.keys == isSplit[0])
                return b[isSplit[1]]
            }
        },
        handleEdit(keyis, obj) {
            let self = this
            this.innerDrawer = true
            this.form.T_uuid = keyis.T_ProductJson.T_uuid
            this.form.T_sn = keyis.T_sn
            this.form.T_password = keyis.T_password
            this.form.T_data = {}
            let isSplit = obj.newId.split('.')
            if (isSplit.length == 1) {
                self.settab = isSplit[0].slice(0, isSplit[0].length - 1)
            } else {
                self.settab = isSplit[0]
            }

            this.isFormList = []
            let array = [...obj.children]
            let findArr = [...keyis.T_dataJson]
            this.$set(this.form.T_data, self.settab, {})
            if (obj.T_type == 10) {
                array.forEach(el => {
                    let swi = el.newId.split('.')
                    for (let i = 0; i < findArr.length; i++) {
                        if (findArr[i].keys == swi[0]) {
                            let iftype = typeof (findArr[i][swi[1]])
                            self.isFormList.push({
                                label: el.T_tab,
                                value: iftype == 'boolean' ? JSON.stringify(findArr[i][swi[1]]) : findArr[i][swi[1]],
                                types: el.T_type
                            })
                            break;
                        }
                    }
                });

            } else {
                for (let j = 0; j < findArr.length; j++) {
                    if (isSplit[0] == findArr[j].keys) {
                        let iftype = typeof (findArr[j][isSplit[1]])
                        self.isFormList.push({
                            label: isSplit[1],
                            value: iftype == 'boolean' ? JSON.stringify(findArr[j][isSplit[1]]) : findArr[j][isSplit[1]],
                            types: obj.T_type
                        })
                        break;
                    }
                }
            }

            console.log('编辑', this.isFormList, this.form)
        },
        onSubmit() {
            const rules = this.isFormList.filter(item => item.types == 4)
            let values = rules.map(rule => rule.value);
            const b = values.every(item => item == 'true' || item == 'false')
            if (!b) {
                this.$message.error('请检查是否存在输入了错误参数')
                return
            } else {
                var arrData = [...this.isFormList]
                let obj = { ...this.form }
                for (let j = 0; j < arrData.length; j++) {
                    let isData = arrData[j].value == 'true' || arrData[j].value == 'false' ? this.returnBoolean(arrData[j].value) : arrData[j].value
                    this.$set(obj.T_data[this.settab], arrData[j].label, isData)
                }
                obj.T_data = JSON.stringify(obj.T_data)
                DevicepushFun(obj).then(res => {
                    if (res.Code == 200) {
                        this.innerDrawer = false
                        this.$message.success('编辑成功')
                        this.getGroupList()
                    }
                })
            }
        },
        returnBoolean(value) {
            if (value == "true") {
                return Boolean(true)
            } else {
                return Boolean(false)
            }
        },
        blurFun(data) {
            console.log('121', data.types, data)
            if (data.types == 4 && !['true', 'false'].includes(data.value)) {
                return true
            }
        },
    },
}
</script>
<style lang="scss">
:root {
    --meter-width: 200px;
    --meter-height: 170px;
}

.manage {
    flex: 1;
    overflow: hidden;
    display: flex;
    border: 1px solid rgba(#00bfff, .2);
    // background: rgba(#00bfff, .03);
    padding: 20px;
    margin: 30px;

    &_left {
        flex-shrink: 0;
        width: 300px;
        background: url('./img/left-bg.png');
        background-size: 100% 100%;
        background-position: left;
        background-repeat: no-repeat;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;

        &__title {
            height: 7%;
            font-size: 16px;
            font-weight: 600;
            color: #007bff;
            padding: 0 10px 0 30px;
            line-height: 20%;
            font-style: oblique;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &__content {
            overflow: auto;
            padding: 0 10px;

            /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
            &::-webkit-scrollbar {
                display: none;
            }

            /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
            -ms-overflow-style: none;
            /* IE 和 Edge */
            scrollbar-width: none;

            /* Firefox */
            &_item {
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-weight: 500;
                margin-top: 10px;
                color: #007bff;
                background: linear-gradient(to right, rgba(0, 191, 255, 0.07), transparent);
                cursor: pointer;
                padding-left: 20px;
                transition: all 0.3s ease;

                &:hover {
                    transform: scale(0.95);
                }
            }
        }
    }

    &_right {
        flex: 1;
        border: 1px solid rgba(#00bfff, .2);
        margin-left: 20px;
        display: flex;
        flex-direction: column;

        &-top {
            margin: 0 20px;
            padding: 20px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid rgba(#00bfff, .2);

            &_maisn {
                flex: 1;
                display: flex;

                &_left {
                    width: var(--meter-width);
                    height: var(--meter-height);
                    background: url('./img/meter.png');
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    color: #007bff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    div:nth-child(1) {
                        font-size: 24px;
                    }

                    div:nth-child(2) {
                        font-size: 12px;
                        margin-top: 5px;
                    }
                }

                &_right {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-left: 20px;

                    &_item {
                        line-height: 34px;
                        font-size: 14px;
                        color: #007bff;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                    }
                }
            }

            &_btn {
                background: url('./img/tab1.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                height: 40px;
                width: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 20px;
                cursor: pointer;
                color: #007bff;

                &:hover {
                    background: url('./img/tab2.png');
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    color: red;
                    transition: all 0.3s ease;
                    transform: scale(1.05);
                }
            }
        }

        &-bottom {
            flex: 1;
            margin: 20px;

            // 去掉表格背景
            .el-table {
                background-color: transparent !important;

                // 给表格内容区域添加滚动和隐藏滚动条样式
                .el-table__body-wrapper {
                    overflow-y: auto;

                    /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
                    &::-webkit-scrollbar {
                        display: none;
                    }

                    /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
                    -ms-overflow-style: none;
                    /* IE 和 Edge */
                    scrollbar-width: none;
                    /* Firefox */
                }
            }

            // 去掉表格行背景
            .el-table__body tr,
            .el-table__header tr {
                background-color: transparent !important;
            }

            // 设置表格表头文字颜色
            .el-table__header th {
                color: #007bff;
            }

            // 设置表格表头背景颜色
            .el-table th.el-table__cell {
                background-color: rgba(#007bff, .4);
                border-bottom: none !important;
            }

            // 设置表格表体文字颜色
            .el-table__body td {
                color: #007bff;
            }

            // 修改表格单元格边框颜色
            .el-table__body td,
            .el-table__header th {
                border: none;
            }

            .el-table::before {
                background-color: transparent !important;
            }

            tr:hover>td.el-table__cell {
                background-color: rgba(#007bff, .1) !important;
                cursor: pointer;
            }

            .el-table__expand-icon {
                color: #007bff;
                font-size: 16px;
            }

        }
    }
}

.activestyles {
    background: linear-gradient(to right, rgba(0, 191, 255, 0.3), transparent);
}

.meterStyle {
    background: url('./img/meterError.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: red !important;
}
</style>
<style lang="scss" scoped>
// 使用深度选择器修改 el-drawer 样式
::v-deep .el-drawer {
    border: 2px solid rgba(#007bff, .7);
    background-color: rgba(#007bff, .1);
    box-shadow: 0 0 20px rgba(#007bff, 0.5) inset;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px); // Safari 浏览器支持

    .el-form-item__label {
        color: #007bff;
    }

    .el-input__inner {
        background-color: rgba(#007bff, .1);
        border: 1px solid #007bff;
        color: rgba(#007bff, 1);
    }

    // 修改抽屉标题样式
    .el-drawer__header {
        color: #007bff;
        font-size: 18px;
        padding: 20px;
    }

    // 修改抽屉内容样式
    .el-drawer__body {
        color: #007bff;
        padding: 20px;
    }

    // 修改抽屉关闭按钮样式
    .el-drawer__close-btn {
        color: #007bff;
        font-size: 20px;

        &:hover {
            color: red;
        }
    }
}

// 已有代码</style>